module.exports = __webpack_public_path__ + "img/826e402717831014b49990d653c95d14.svg";